import styled from 'styled-components';

export const OrderDetailWrapper = styled.div`
  .ant-input-number-handler-wrap {
    display: none;
    pointer-event: none;
  }
`;
